import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { EbookMockup } from './ui/EbookMockup';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden bg-gradient-to-br from-brand-cream via-brand-cream to-brand-blush/60" data-id="element-109">
      {/* Soft radial glow behind ebook */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[800px] h-[800px] bg-brand-rose/5 rounded-full blur-3xl pointer-events-none hidden lg:block" data-id="element-110" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-111">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-8" data-id="element-112">
          {/* Left Column: Text */}
          <div className="w-full lg:w-[55%] text-center lg:text-left pt-8 lg:pt-0" data-id="element-113">
            <FadeIn delay={0.1} data-id="element-114">
              <div className="inline-flex items-center gap-2 py-1.5 px-4 rounded-full bg-white border border-brand-blush shadow-sm mb-8" data-id="element-115">
                <span className="text-brand-rose" data-id="element-116">🔥</span>
                <span className="text-brand-brown font-medium text-sm" data-id="element-117">
                  Mais de 200 empreendedoras
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-118">
              <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold text-brand-brown leading-[1.15] mb-6" data-id="element-119">
                Transforme sua paixão por velas em um{' '}
                <span className="text-brand-rose italic relative inline-block" data-id="element-120">
                  negócio lucrativo
                  <svg className="absolute -bottom-2 left-0 w-full h-3 text-brand-gold/40" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-121">
                    <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="none" data-id="element-122" />
                  </svg>
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-123">
              <p className="text-lg sm:text-xl text-brand-brown/80 mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-124">
                O guia definitivo passo a passo para você começar do zero, criar
                velas aromáticas perfeitas e faturar trabalhando no conforto da
                sua casa.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-125">
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-6" data-id="element-126">
                <motion.a href="#oferta" whileHover={{
                scale: 1.03
              }} whileTap={{
                scale: 0.97
              }} className="w-full sm:w-auto bg-brand-rose text-white px-8 py-4 rounded-full font-bold text-lg shadow-xl shadow-brand-rose/20 hover:bg-brand-rose/90 transition-colors text-center" data-id="element-127">
                  Receber Ebook Agora
                </motion.a>
                <motion.a href="#conteudo" whileHover={{
                scale: 1.03
              }} whileTap={{
                scale: 0.97
              }} className="w-full sm:w-auto bg-white text-brand-brown border-2 border-brand-blush px-8 py-4 rounded-full font-bold text-lg hover:border-brand-rose/50 hover:bg-brand-cream transition-colors text-center" data-id="element-128">
                  Ver Conteúdo
                </motion.a>
              </div>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-4 gap-y-2 text-sm text-brand-brown/60 font-medium" data-id="element-129">
                <span className="flex items-center gap-1" data-id="element-130">
                  ✓ 7 dias de garantia
                </span>
                <span className="hidden sm:inline" data-id="element-131">•</span>
                <span className="flex items-center gap-1" data-id="element-132">
                  ✓ Acesso imediato
                </span>
                <span className="hidden sm:inline" data-id="element-133">•</span>
                <span className="flex items-center gap-1" data-id="element-134">✓ +100 páginas</span>
              </div>
            </FadeIn>
          </div>

          {/* Right Column: Visual */}
          <div className="w-full lg:w-[45%] flex justify-center lg:justify-end relative" data-id="element-135">
            <FadeIn delay={0.5} direction="left" className="relative z-10 w-full max-w-md flex justify-center" data-id="element-136">
              <EbookMockup size="lg" data-id="element-137" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}